<template>
    <header id="header" class="header">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="header-wrapper d-flex">
                        <logo />
                            <div id="header-navs" class="header-navs d-flex" :class="fixedNavs ? 'header-navs--fixed' : ''">
                                    <Menu :media="media" />
                                    <Auth :isLog="isLog" :media="media" />
                            </div>
                    </div>
                </div>
            </div>
        </div>

    </header>
</template>

<script>
    import Menu from './Menu';
    import Logo from './Logo';
    import Auth from './Auth';
    export default {
        name: 'MainMenu',
        components: {
            Menu,
            Logo,
            Auth
        },
        data(){
            return{
                media: '',
                fixedNavs: false,
            }
        },
        created() {
            this.myEventHandler()

            window.addEventListener("resize", this.myEventHandler);
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener("resize", this.myEventHandler);
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.handleScroll()
        },

        computed:{

            isLog() {

                return this.$store.getters.getUserData

            }


        },

        methods:{
            myEventHandler(e){
                this.media = window.innerWidth
            },
            handleScroll (e) {
                if( this.media >  768) return
                let navs = document.getElementById('header-navs');
                let headerHeight = document.getElementById('header').offsetHeight

                if(window.pageYOffset >= headerHeight) {
                    return this.fixedNavs = true
                }

                this.fixedNavs = false
            },

        },


    }
</script>

<style lang="scss">
    @import '../../../sass/helpers';
    .header{
        background-color: #fff;
        padding: 30px 0;
        &-wrapper{
            width: 100%;
            align-items: stretch;
        }

        &-navs{
            position: relative;
            flex-grow: 1;
            background-color: #fff;
            &--fixed{
                position: fixed;
                padding: 10px 15px;
                top: -100%;
                left: 0;
                right: 0;
                z-index: 900;
                animation: slideIn .5s ease-out;
                animation-fill-mode: forwards;
            }
        }
        .auth{
            &__office{
                height: 100%;
                align-items: flex-start;
                &-item{
                    position: relative;
                    padding: 0 10px;

                    &:last-child{
                        padding-right: 0;
                    }
                }
                &-link{
                    display: block;
                    position: relative;
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;


                    img,
                    svg{
                        margin: 0;
                        width: 100%;
                    }

                    &--toggle-size{

                        svg{
                            height: 20px;
                        }
                    }

                }
                &-count{
                    position: absolute;
                    display: block;
                    right: -2px;
                    top: -2px;
                    text-align: center;
                    background-color: #EE7372;
                    width: 22px;
                    height: 22px;
                    font-size: 12px;
                    line-height: 22px;
                    color: #fff;
                    border-radius: 100%;

                    &--secondary{
                        background-color: #91DA66;
                    }
                }

                &-item--client{
                    padding-right: 0;

                    .auth__office-link{
                        border-radius: 100%;
                        overflow: hidden;
                        color: #fff;
                        background-color: #91DA66;
                        span{
                            position: absolute;
                            left: 0;
                            right: 0;
                            top: 0;
                            bottom: 0;
                            text-align: center;
                            line-height: 42px;
                        }
                    }


                }

            }


        }

        .notice{
            position: absolute;
            padding-top: 15px;
            top: 90%;
            right: -10px;
            width: 430px;
            z-index: 1000;
            &__see-all{
                color: $primaryBlue;
                transition: opacity .2s ease;

                &:hover{
                    opacity: .8;
                }
            }

            &__item{
                background: #fff;
                position: relative;
                width: 100%;
                border-top: 1px solid $primaryBlue;
                box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
                &::before{
                    position: absolute;
                    display: block;
                    content: '';
                    top: -8px;
                    right: 30px;
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-width: 0 8px 8px 8px;
                    border-color: transparent transparent $primaryBlue transparent;
                }

                &-header{
                    justify-content: space-between;
                    align-items: center;
                    padding: 22px 16px;
                    border-bottom: 1px solid #F1F2F4;

                }

                &-title{
                    font-size: 18px;
                    font-weight: 500;
                }

                &-body{
                    &--empty{
                        height: 150px;
                        justify-content: center;
                        align-items: center;
                    }
                }

            }
            &__message{
                position: relative;
                padding: 20px 50px 20px 15px;
                border-bottom: 1px solid #F1F2F4;
                transition: background-color .2s ease;
                &-img{
                    position: relative;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    background-color: transparent;
                    font-weight: 700;
                    width: 40px;
                    height: 40px;
                    line-height: 42px;
                    border-radius: 100%;
                    overflow: hidden;
                    min-width: 40px;

                    img{
                        position: relative;
                        width: 100%;
                        height: auto;
                        z-index: 2;
                    }

                    span{
                        position: absolute;
                        top: 1px;
                        left: 1px;
                        width: 38px;
                        height: 38px;
                        border-radius: 50%;
                        z-index: 1;
                        background-color: transparent;
                    }
                }

                &-content{
                    padding: 0 30px 0 20px;
                }

                &-text{
                    font-size: 12px;
                    color: #929292;
                    line-height: 16px;
                    margin-bottom: 10px;
                }

                &-name{
                    font-size: 14px;
                    line-height: 16px;
                    font-weight: 500;
                    color: #333333;
                }

                &-pet{
                    color: $primaryBlue;
                    font-size: 16px;
                    margin-bottom: 10px;
                }

                &-time{
                    color: #929292;
                    font-size: 12px;
                    line-height: 12px;
                }

                &-icon{
                    position: absolute;
                    background: #FEF9EC no-repeat center/contain;
                    top: 20px;
                    right: 20px;
                    width: 30px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    border-radius: 100%;
                    overflow: hidden;
                }

                &:last-child{
                    border-bottom: none;
                }

                &:nth-child(1),
                &:nth-child(4n + 1){
                    .notice__message-img{
                        span{
                            background-color: #91DA66;
                        }

                    }
                }
                &:nth-child(2),
                &:nth-child(4n + 2){
                    .notice__message-img{
                        span{
                            background-color: #6C4DBB;
                        }


                    }
                }
                &:nth-child(3),
                &:nth-child(4n + 3){
                    .notice__message-img{
                        span{
                            background-color: #2E76E4;
                        }
                    }
                }
                &:nth-child(4),
                &:nth-child(4n + 4){
                    .notice__message-img{
                        span{
                            background-color: #91DA66;
                        }

                    }
                }

                &:hover{
                    background-color: #F1F2F4;
                }
            }

            .auth-user{

                &::before{
                    right: 22px;
                }


                .notice__item-header{
                    justify-content: flex-start;
                }



                .notice__item-img{
                    position: relative;
                    width: 34px;
                    height: 34px;
                    min-width: 34px;
                    border-radius: 100%;
                    overflow: hidden;
                    background: #91DA66;
                    color: #fff;
                    font-weight: 500;
                    text-align: center;
                    line-height: 35px;
                    img{
                        position: relative;
                        width: 100%;
                        height: auto;
                        z-index: 1;
                    }
                    span{
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        background-color: transparent;
                        z-index: 0;
                    }
                }

                .notice__item-title{
                    padding-left: 15px;
                    font-size: 14px;
                }

                &__subtitle{
                    font-size: 10px;
                    line-height: 10px;
                    color: $primaryBlue;
                }


                .notice__item-body{
                    padding: 8px 16px;
                }

                &__list{
                    padding: 0;
                    margin: 0;
                    list-style: none;
                    color: #929292;
                    font-size: 14px;
                    line-height: 14px;
                }

                &__icon{
                    width: 15px;
                    height: 15px;
                    position: absolute;
                    top: 50%;
                    left: 5px;
                    transform: translateY(-50%);
                    color: inherit;
                    background: url('/assets/images/icons/profile.svg') no-repeat center/contain;
                    &.profile{
                        background-image: url('/assets/images/icons/profile.svg');
                    }

                    &.notice{
                        background-image: url('/assets/images/icons/notice.svg');
                    }

                    &.setting{
                        background-image: url('/assets/images/icons/settings.svg');
                    }

                    &.dashboard{
                        background-image: url('/assets/images/icons/dashboard.svg');
                    }

                    &.transaction{
                        background-image: url('/assets/images/icons/transaction.svg');
                    }

                    &.less{
                        background-image: url('/assets/images/icons/less.svg');
                    }

                    &.add{
                        background-image: url('/assets/images/icons/add.svg');
                    }

                    &.exit{
                        background-image: url('/assets/images/icons/exit.svg');
                    }

                }


                &__link{
                    display: block;
                    position: relative;
                    padding: 10px 10px 10px 30px;
                    color: #555;
                    font-size: inherit;
                    line-height: inherit;
                    transition: color .2s ease, background-color .2s ease;
                    border-radius: 4px;



                    &:hover{
                        background-color: $primaryBlue;
                        color: #fff;

                        .auth-user__icon{
                            &.profile{
                                background-image: url('/assets/images/icons/profile-white.svg');
                            }

                            &.notice{
                                background-image: url('/assets/images/icons/notice-white.svg');
                            }

                            &.setting{
                                background-image: url('/assets/images/icons/settings-white.svg');
                            }
                            &.dashboard{
                                background-image: url('/assets/images/icons/dashboard-white.svg');
                            }

                            &.transaction{
                                background-image: url('/assets/images/icons/transaction-white.svg');
                            }

                            &.less{
                                background-image: url('/assets/images/icons/less-white.svg');
                            }

                            &.add{
                                background-image: url('/assets/images/icons/add-white.svg');
                            }

                            &.exit{
                                background-image: url('/assets/images/icons/exit-white.svg');
                            }

                        }

                    }
                }



            }


            &--notofication{
                .notice__item-body{
                    max-height: 550px;
                    overflow: auto;
                }
            }

            &--messages{
                width: 410px;

                .notice__item-body{
                    max-height: 390px;
                    overflow: auto;
                }
            }

            &--user{
                width: 290px;
            }
        }
        .auth-user{
            &__widgets{
                padding: 10px 22px;
                border-bottom: 1px solid #F1F2F4;
                background-color: #fff;
                justify-content: center;

                .auth__office-link{
                    position: relative;
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: center;
                    align-items: center;
                    width: 60px;
                    height: 40px;
                    line-height: 40px;
                    padding: 10px 20px;

                    svg{
                        width: 100%;
                        height: auto;
                        display: block;
                    }

                    .auth__office-count{
                        position: absolute;
                        right: 10px;
                        top: 0;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        font-size: 10px;
                        color: #fff;
                        font-weight: 700;
                        border-radius: 100%;
                        overflow: hidden;
                        background-color: #EE7372;

                        &--secondary{
                            background-color: #91DA66;
                        }
                    }
                }


            }
        }

        @media screen and (max-width: 1200px) {

            .auth{
                &__office{
                    &-item{
                        padding: 0 5px;
                    }
                }
            }

            .notice{
                &__item{
                    &::before{
                        right: 25px;
                    }
                }

            }

        }
        @media screen and (max-width: 992px) {
            padding: 15px 0;

            .auth{
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                width: 100px;
                justify-content: flex-end;
            }

        }

        @media screen and (max-width: 768px) {
            .auth {
                max-height: 50px;
                width: auto;
            }

            &-wrapper{
                flex-direction: column;
            }

            &__widgets{
                align-items: center;
            }

            &-navs{
                &::after{
                    position: absolute;
                    display: block;
                    content: '';
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 2px;
                    background: #F1F2F4;
                    border-radius: 5px;
                }
            }

            .social .social__list .social__item{
                margin-bottom: 0;
            }

        }

        @media screen and (max-width: 500px){
            .auth{
                width: 75px;
                justify-content: flex-end;
            }



        }
        @media screen and (max-width: 400px){
            .auth{
                width: 60px;
            }
        }

    }

    @keyframes slideIn {
        from{
            top: -100%;
        }
        to{
            top:0;
        }
    }

</style>

